<div class="d-flex h-100">
  <div style="position: relative;min-width: 339px;">
    <app-sidebar></app-sidebar>
  </div>
  <div class="w-100 h-100 d-flex flex-column">
    <div style="position: sticky;top: 0;z-index: 1;">
      <app-header></app-header>
    </div>
    <div style="flex-grow: 1;">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>